import { getMe, postUserCardV2, putUserCardV2 } from '@/apis';
import { paths } from '@/config';
import notify from '@/migration/notification';
import { useQuery } from '@/utils';
import { useEffect } from 'react';
import { useHistory } from 'react-router';

export const useCreditCallback = () => {
  const searchParams = window.location.search;
  const params = new URLSearchParams(searchParams);
  const history = useHistory();

  const { data: me } = useQuery({
    queryFn: getMe,
    queryKey: ['me'],
  });

  const { isLoading, error, data } = useQuery({
    queryFn: async () => {
      if (me?.isCustomer) {
        return putUserCardV2({
          userId: me?.id,
          setup_intent: params.get('setup_intent') ?? '',
          setup_intent_client_secret:
            params.get('setup_intent_client_secret') ?? '',
          redirect_status: params.get('redirect_status') ?? '',
        });
      }

      return postUserCardV2({
        userId: me?.id,
        setup_intent: params.get('setup_intent') ?? '',
        setup_intent_client_secret:
          params.get('setup_intent_client_secret') ?? '',
        redirect_status: params.get('redirect_status') ?? '',
      });
    },
    queryKey: ['credit-callback', me],
    enabled: !!me,
  });

  useEffect(() => {
    if (error) {
      history.replace(paths.mypage.credit);
      notify('カード情報の登録に失敗しました。', 'error', undefined, 5);
    }
    if (data) {
      history.replace(paths.mypage.credit);
      notify('カード情報の登録に成功しました。', 'info', undefined, 5);
    }
  }, [error, data]);

  return {
    params,
    isLoading,
    error,
  };
};
